import { isRunningInIOSWebview, storageType } from "../utils/environment";
import { DataStorage } from "./DataStorage";
import webViewStorageHandler from "./WebViewStorageHandler";
import idbKeyVal from "./idbKeyVal";
import { webDB } from "./WebDB";
import { nativeDB } from "./NativeDB";

export const storage: DataStorage = storageType === "sqlite" ? webViewStorageHandler : idbKeyVal;

export const db = isRunningInIOSWebview ? nativeDB : webDB;

console.log(`[storage] Using ${isRunningInIOSWebview ? "SQLite (NativeDB)" : "IndexedDB (Dexie)"} as database backend`);
